import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  container: {
    background: "#111622",
    color: "#FFF",
    padding: "6px 16px",
    borderRadius: 24,
    border: "1.5px solid rgba(255, 255, 255, 0.20)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    fontSize: 14,
    width: 84,
    height: 26,
    transition: "all 0.3s ease-in-out",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },
  directionUp: {
    color: "#4CAF50",
  },
  directionDown: {
    color: "#F44336",
  },
  fade: {
    transition: "opacity 0.4s ease",
    opacity: 1,
  },
  hidden: {
    opacity: 0,
  },
  rank: {
    lineHeight: "normal !important",
  },
});
